// This list is important for NextSEO meta tags
// When new supported locales are added, please update this list
const validLocales = ["de-DE", "de-AT", "de-CH", "pl-PL"]

export default validLocales
